module.exports = __webpack_public_path__ + "img/twitter.d716d19e.png";